import React from 'react';
import { HeartIcon } from 'lucide-react';
export function OurStory() {
  return <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-amber-50 to-white" data-id="element-236">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-237">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-[rgb(var(--color-neutral-900))] mb-4 sm:mb-6" data-id="element-238">
          De Harde Waarheid over Hondenvoeding die Wij Zelf Ontdekten
        </h2>

        <div className="max-w-4xl mx-auto mb-8 sm:mb-12" data-id="element-239">
          <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] mb-4 sm:mb-6 leading-relaxed" data-id="element-240">
            Ook wij zagen deze problemen bij onze eigen honden en die van onze
            klanten. Daarom zijn we met ons hele team, inclusief onze
            voedingsdeskundige, op zoek gegaan naar wat nou écht de beste
            voeding is voor honden. We hebben alles uitgeprobeerd, maar kwamen
            er al snel achter dat veel voeding (ook van bekende merken)
            nauwelijks aansluit bij wat een hond vanuit zijn natuur nodig heeft.
          </p>

          <div className="bg-red-50 border-l-4 border-red-600 p-5 sm:p-6 rounded-lg mb-6" data-id="element-241">
            <h3 className="text-lg sm:text-xl font-bold text-[rgb(var(--color-neutral-900))] mb-3" data-id="element-242">
              Wat we ontdekten was confronterend:
            </h3>
            <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] leading-relaxed" data-id="element-243">
              De grote voedingsmerken zijn vooral goed in het laag houden van
              productiekosten. Maar daardoor schieten ze tekort in wat echt
              gezond is voor de hond. Het resultaat? Jij betaalt later de prijs.
              Letterlijk. Want dan ga je met je hond naar de dierenarts voor
              gezondheidsproblemen, of naar een gedragsdeskundige omdat je hond
              niet lekker in zijn vel zit door lichamelijke klachten.
            </p>
          </div>
        </div>

        <div className="testimonial-section" data-id="element-244">
          <div className="testimonial-card" data-id="element-245">
            <div className="quote-icon" data-id="element-246">
              <span data-id="element-247">❝</span>
            </div>

            <blockquote className="testimonial-text" data-id="element-248">
              <p data-id="element-249">
                Haar hond had altijd last van jeuk en beet constant op haar
                voorpootjes, een veelvoorkomend probleem dat vaak wordt afgedaan
                als 'gewoon een gevoelige hond'. Maar na een aantal weken op
                deze natuurlijke voeding verdween de jeuk volledig. Haar hond
                stopte met bijten op haar poten. Ook andere lichamelijke
                klachten werden duidelijk minder.
              </p>
            </blockquote>

            <div className="testimonial-author" data-id="element-250">
              <div className="author-avatar" data-id="element-251">
                <span className="avatar-icon" data-id="element-252">❤️</span>
              </div>
              <div className="author-info" data-id="element-253">
                <p className="author-name" data-id="element-254">Amber</p>
                <p className="author-title" data-id="element-255">Hondencoach</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 max-w-4xl mx-auto" data-id="element-256">
          <h3 className="text-xl sm:text-2xl font-bold text-center text-[rgb(var(--color-neutral-900))] mb-6 sm:mb-8" data-id="element-257">
            Niet alleen lichamelijk, ook gedragsmatig
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-258">
            {[{
            icon: '😌',
            title: 'Rustiger gedrag',
            description: 'Honden die meer ontspannen zijn'
          }, {
            icon: '🎯',
            title: 'Betere focus',
            description: 'Kunnen zich beter concentreren'
          }, {
            icon: '💪',
            title: 'Minder angst',
            description: 'Zelfverzekerder en stabieler'
          }].map((result, index) => <div key={index} className="bg-gradient-to-br from-green-50 to-emerald-50 p-5 sm:p-6 rounded-xl text-center border border-green-200" data-id="element-259">
                <div className="text-4xl sm:text-5xl mb-3" data-id="element-260">{result.icon}</div>
                <h4 className="font-bold text-base sm:text-lg text-[rgb(var(--color-neutral-900))] mb-2" data-id="element-261">
                  {result.title}
                </h4>
                <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))]" data-id="element-262">
                  {result.description}
                </p>
              </div>)}
          </div>

          <p className="text-center text-base sm:text-lg text-[rgb(var(--color-neutral-800))] mt-6 sm:mt-8 italic" data-id="element-263">
            Logisch eigenlijk - als je lichaam niet lekker voelt, gedraag je je
            ook anders.
          </p>
        </div>
      </div>
    </section>;
}